import '../../../../assets/css/screens/serviceprovider/dashboard/workerhome/WorkerHome.css';
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Bell, MapPin, Briefcase, CheckCircle, DollarSign,
  Star, TrendingUp, Calendar, ArrowRight,
  Clock, CheckCheck, AlertCircle, Award, Power, Crown
} from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import MyNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';



const STATUS_CFG = {
  assigned: {
    color: '#8b5cf6',
    bg: 'rgba(139,92,246,0.10)',
    icon: <CheckCircle size={12} />
  },

  in_progress: {
    color: '#0491e1',
    bg: 'rgba(4,145,225,0.10)',
    icon: <Clock size={12} />
  },

  awaiting_confirmation: {
    color: '#f59e0b',
    bg: 'rgba(245,158,11,0.10)',
    icon: <AlertCircle size={12} />
  },

  completed: {
    color: '#10b981',
    bg: 'rgba(16,185,129,0.10)',
    icon: <CheckCheck size={12} />
  }
};

const WorkerHome = () => {
  const [activeJobs, setActiveJobs] = useState([]);
  const [newJobs, setNewJobs] = useState([]);
  const { baseUrl, authToken, kycStatus } = useContext(AppContext);
  const navigate = useNavigate();
  const [availablity, setAvailablity] = useState(false); // Availablity toggle state
  const [fullName, setFullName] = useState('');
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good Morning' : hour < 17 ? 'Good Afternoon' : 'Good Evening';
  const emoji = hour < 12 ? '🌅' : hour < 17 ? '👋' : '🌙';
  // fetch activejobs
  const [stats, setStats] = useState({
    activeJobs: 0,
    completedJobs: 0,
    rating: 0
  });
  const getDashboardStats = () => {

    axios.get(`${baseUrl}/worker/viewactivejobs`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then((response) => {

        setActiveJobs(response.data.activeJobs);

        setFullName(response.data.worker.name);
        setAvailablity(response.data.worker.is_available);

        setNewJobs(response.data.newJobs);

      })
      .catch((error) => {
        console.log(error);
      });

  };

  const handleAvailablityToggle = async () => {
    try {
      const newStatus = !availablity;

      // optimistic UI update
      setAvailablity(newStatus);

      const response = await axios.post(
        `${baseUrl}/update/availability`,
        {
          is_available: newStatus
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        }
      );

      console.log("Updated successfully:", response.data);

    } catch (error) {
      console.log(error);

      // rollback if error occurs
      setAvailablity(prev => !prev);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Could not update availability"
      });
    }
  };

  // const getupcomingjobs = () => {

  //   axios.get(`${baseUrl}/worker/viewupcomingjobs`, {
  //     headers: {
  //       Authorization: `Bearer ${authToken}`
  //     }
  //   })
  //   .then((response) => {

  //     setActiveJobs(response.data.upcomigJobs);
  //     setNewJobs(response.data.newJobs);

  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });

  // };

  useEffect(() => {
    getDashboardStats();
  }, []);

  // const handleAvailablityToggle = () => {
  //   setAvailablity(prev => !prev);
  //   // Add your API call here to update availablity status
  //   console.log('Availablity status:', !availablity ? 'Available' : 'Unavailable');
  // };

  return (
    <div className="wh-page">
      <MyNavbar />

      {/* ══ MOBILE HERO ══ */}
      <div className="wh-hero">
        {/* Top row */}
        <div className="wh-hero__toprow">
          <div className="wh-hero__avatar" >
            <span onClick={() => navigate('/worker-profile')}>MA</span>
          </div>
          <div className="wh-hero__greeting">
            <span className="wh-hero__good">{greeting} {emoji}</span>
            <span className="wh-hero__name">
              Hello {fullName}
            </span>
          </div>
          <button className="wh-hero__bell" onClick={() => navigate('/worker-notifications')}>
            <Bell size={20} />
            <span className="wh-hero__bell-dot" />
          </button>
        </div>

        {/* Earnings card inside hero */}
        <div className="wh-hero__card">
          <div className="wh-hero__card-left">
            <span className="wh-hero__card-week">
              <TrendingUp size={13} /> This Week
            </span>
            <span className="wh-hero__card-amount">$8,500</span>
            <span className="wh-hero__card-jobs">12 jobs completed</span>
          </div>
          {/* <div className="wh-hero__card-right">
            <div className="wh-hero__badge">
              <Crown size={22}/>
              <span>Get Pro</span>
            </div>
          </div> */}
          <div className="wh-hero__card-right">
            <div
              className="wh-hero__badge"
              onClick={() => navigate('/workersubscription')}
            >
              <Crown size={18} />
              <span>Get Pro</span>
            </div>
          </div>
        </div>

        {/* Location & Activity Toggle */}
        <div className="wh-hero__bottom">
          <div className="wh-hero__location">
            <MapPin size={13} /> Portland, USA
          </div>

          {/* Activity Toggle Button */}
          <button
            className={`wh-availablity-toggle ${availablity ? 'wh-available-toggle--available' : ''}`}
            onClick={handleAvailablityToggle}
          >
            <Power size={14} />
            <span>{availablity ? 'Available' : 'Unavailable'}</span>
          </button>
        </div>
      </div>

      {/* ══ DESKTOP HEADER (hidden mobile) ══ */}
      <div className="wh-desk-header">
        <div>
          <h2 className="wh-desk-header__title">Hello {fullName}</h2>
          <p className="wh-desk-header__sub">Here's what's happening with your jobs today.</p>
        </div>

        {/* Desktop Activity Toggle */}
        <button
          className={`wh-availablity-toggle wh-available-toggle--desktop ${availablity ? 'wh-availablity-toggle--available' : ''}`}
          onClick={handleAvailablityToggle}
        >
          <Power size={16} />
          <span>{availablity ? 'Available' : 'Unavailable'}</span>
        </button>
      </div>

      {/* ══ CLICKABLE STATS ══ */}
      <div className="wh-stats">
        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#0491e1', '--sb': 'rgba(4,145,225,0.12)' }}
          onClick={() => navigate('/bid-jobs')}
        >
          <div className="wh-stat__icon"><Briefcase size={20} /></div>
          <strong className="wh-stat__val">3</strong>
          <span className="wh-stat__label">Active Jobs</span>
        </div>

        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#10b981', '--sb': 'rgba(16,185,129,0.12)' }}
          onClick={() => navigate('/bid-jobs')}
        >
          <div className="wh-stat__icon"><CheckCircle size={20} /></div>
          <strong className="wh-stat__val">47</strong>
          <span className="wh-stat__label">Completed</span>
        </div>

        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#f59e0b', '--sb': 'rgba(245,158,11,0.12)' }}
          onClick={() => navigate('/worker-earnings')}
        >
          <div className="wh-stat__icon"><DollarSign size={20} /></div>
          <strong className="wh-stat__val">$24.5K</strong>
          <span className="wh-stat__label">Earnings</span>
        </div>

        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#f59e0b', '--sb': 'rgba(245,158,11,0.12)' }}
          onClick={() => navigate('/worker-profile')}
        >
          <div className="wh-stat__icon"><Star size={20} /></div>
          <strong className="wh-stat__val">4.8</strong>
          <span className="wh-stat__label">Rating</span>
        </div>
      </div>

      {/* ══ ACTIVE JOBS ══ */}
      {kycStatus === "approved" && activeJobs?.length > 0 && (
        <div className="wh-section">
          <div className="wh-section__header">
            <h2 className="wh-section__title">Active Jobs</h2>
            <button className="wh-view-all" onClick={() => navigate('/bid-jobs')}>
              View All <ArrowRight size={13} />
            </button>
          </div>

          <div className="wh-jobs">
            {activeJobs.map((j, i) => {
              const st = STATUS_CFG[j.status];

              return (
                <div key={j.id} className="wh-job-card">
                  <div className="wh-job-card__top">
                    <span className="wh-job-card__title">
                      {j.jobTitle}
                    </span>

                    <span
                      className="wh-job-card__badge"
                      style={{
                        color: st?.color,
                        background: st?.bg
                      }}
                    >
                      {st?.icon} {j.status}
                    </span>
                  </div>

                  <div className="wh-job-card__meta">
                    <span>
                      <Calendar size={13} />
                      {new Date(j.created_at).toLocaleDateString()}
                    </span>

                    <span>
                      <MapPin size={13} />
                      {j.address}
                    </span>
                  </div>

                  <div className="wh-job-card__footer">
                    <span className="wh-job-card__customer">
                      {j.whcustomer?.fullName || 'No Customer'}
                    </span>

                    <span className="wh-job-card__price">
                      ${j.budget}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {/* ══ NEW JOB POSTINGS ══ */}
      <div className="wh-section">
        <div className="wh-section__header">
          <h2 className="wh-section__title">New Job Requests</h2>
          <button
            className="wh-view-all"
            onClick={() => {

              if (kycStatus !== "approved") {
                Swal.fire({
                  icon: "warning",
                  title: "KYC Required",
                  text: "Please complete your KYC first."
                });

                navigate('/worker-kyc');
                return;
              }

              navigate('/bid-jobs?tab=new');
            }}
          >
            View All <ArrowRight size={13} />
          </button>
        </div>

        <div className="wh-jobs">
          {newJobs.map((j) => (
            <div
              key={j.id}
              className="wh-job-card"
              onClick={() => navigate('/bid-jobs')}
            >
              <div className="wh-job-card__top">
                <span className="wh-job-card__title">
                  {j.jobTitle}
                </span>

                <span
                  className="wh-job-card__badge"
                  style={{
                    color: "#10b981",
                    background: "rgba(16,185,129,.10)"
                  }}
                >
                  <Briefcase size={12} />
                  New
                </span>
              </div>

              <div className="wh-job-card__meta">
                <span>
                  <Calendar size={13} />
                  {new Date(j.deadline).toLocaleDateString()}
                </span>

                <span>
                  <MapPin size={13} />
                  {j.address}
                </span>
              </div>

              <div className="wh-job-card__footer">
                <span className="wh-job-card__customer">
                  {j.whcustomer?.fullName || "No Customer"}
                </span>

                <span className="wh-job-card__price">
                  ${j.budget}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default WorkerHome;